import { mapRecordFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetOneResponse } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import {
  ICorporatePartPriceListItem,
  IGetActiveOverlappingPricePayload,
  IRemoveCorporatePartPricePayload,
  IUpsertCorporatePartPricePayload,
} from 'corporate/types';

export const upsertCorporatePartPrice = async (data: IUpsertCorporatePartPricePayload) =>
  partfinitiClient.postForm(
    '/corporate/parts/save-price',
    { corporatePartPrice: data },
    { includeNullValues: true }
  );

export const removeCorporatePartPrice = async (data: IRemoveCorporatePartPricePayload) =>
  partfinitiClient.postForm('/corporate/parts/remove-price', data);

export const getActiveOverlappingPrice = async (
  payload: IGetActiveOverlappingPricePayload,
  signal?: AbortSignal
): Promise<GetOneResponse<ICorporatePartPriceListItem>> => {
  const { data } = await partfinitiClient.get(
    `/corporate/parts/get-active-overlapping-price?${getQueryStringToSnakeCase(
      { corporatePartPrice: payload },
      { removeNullValues: true }
    )}`,
    signal
  );

  return mapRecordFromServer<ICorporatePartPriceListItem>(data?.corporate_part_price, true);
};
